import { AccordionDetails, styled } from "@mui/material"

const LassoAccordionDetails = styled(AccordionDetails)({
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderRadius: 0,
    marginInlineStart: '1rem'
})

export default LassoAccordionDetails;